export default __webpack_public_path__ + "static/media/ImageMenu.de457229.png";